export interface INormalizedDatalabRequestError {
  msg?: string;
  code?: string | number;
}

function pickMsgCode(data: Record<string, unknown>): INormalizedDatalabRequestError {
  const msgRaw =
    (typeof data.msg === 'string' && data.msg) ||
    (typeof data.message === 'string' && data.message) ||
    undefined;
  const codeRaw = data.code;
  const code =
    codeRaw !== undefined && codeRaw !== null && codeRaw !== ''
      ? (codeRaw as string | number)
      : undefined;
  return { msg: msgRaw, code };
}

/**
 * 将请求/业务 reject 的 unknown 归一为 { msg, code }，供错误展示使用。
 * 兼容：业务体 { msg, code }、原生 Error、Axios 形 { response.data }、字符串 throw。
 */
export function normalizeDatalabRequestError(
  err: unknown,
): INormalizedDatalabRequestError {
  if (err === null || err === undefined) {
    return {};
  }
  if (typeof err === 'string') {
    return { msg: err };
  }
  if (err instanceof Error) {
    const o = err as unknown as Record<string, unknown>;
    const { code } = pickMsgCode(o);
    return { msg: err.message ?? undefined, code };
  }
  if (typeof err !== 'object') {
    try {
      return { msg: String(err) };
    } catch {
      return {};
    }
  }

  const o = err as Record<string, unknown>;
  let { msg, code } = pickMsgCode(o);

  const { response } = o;
  if ((!msg || code === undefined) && response && typeof response === 'object') {
    const { data } = response as Record<string, unknown>;
    if (data && typeof data === 'object') {
      const inner = pickMsgCode(data as Record<string, unknown>);
      msg = msg ?? inner.msg;
      code = code ?? inner.code;
    }
  }

  return { msg, code };
}
